import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { getIdToken } from '../googleAuthSession'; // request interceptor

type TypedAxiosInstance = Omit<AxiosInstance, 'get' | 'post' | 'put' | 'patch' | 'delete'> & {
  get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>;
  post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>;
  put<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>;
  patch<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>;
  delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>;
};

const one360 = axios.create({
  baseURL: '/one360',
  timeout: 30_000,
}) as TypedAxiosInstance;

// Bearer ID-Token setzen. Kein Token → Request sofort verwerfen statt ohne Auth rausschicken.
one360.interceptors.request.use((config) => {
  if (!config.headers['Authorization']) {
    const token = getIdToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    } else {
      return Promise.reject(
        Object.assign(new Error('Kein Auth-Token verfügbar'), { status: 401, isAuthMissing: true })
      );
    }
  }
  return config;
});

// BaseResponse<T> auspacken und Fehler normalisieren
one360.interceptors.response.use(
  (response) => {
    const body = response.data;
    return body?.data ?? body;
  },
  (error) => {
    if (axios.isCancel(error)) return Promise.reject(error);
    // isAuthMissing = vom Request-Interceptor gesetzt, kein Netzwerkfehler loggen
    if ((error as any).isAuthMissing) return Promise.reject(error);
    const status = error.response?.status;
    if (status === 401 || status === 403) {
      window.dispatchEvent(new CustomEvent('auth:unauthorized'));
    }
    const msg = error.response?.data?.message || error.message || 'One360-Anfrage fehlgeschlagen';
    return Promise.reject(Object.assign(new Error(msg), { status }));
  }
);

export default one360;
